export const RESET_CLUB_ISFETCHING = 'RESET_CLUB_ISFETCHING';
export const GET_CLUB_REQUEST = 'GET_CLUB_REQUEST';
export const GET_CLUB_SUCCESS = 'GET_CLUB_SUCCESS';
export const LIST_CLUBS_REQUEST = 'LIST_CLUBS_REQUEST';
export const CLUB_REQUESTING = 'CLUB_REQUESTING';
export const LIST_CLUBS_SUCCESS = 'LIST_CLUBS_SUCCESS';
export const LIST_CLUBS_SUCCESS_GTM = 'LIST_CLUBS_SUCCESS_GTM';
export const CLUB_CLICK_SUCCESS_GTM = 'CLUB_CLICK_SUCCESS_GTM';
